<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->
<div class="modal-inner-wrapper" ngDraggable [handle]="ModalHandle">
  <div class="modal-header">
    <h4 class="modal-title">
      <span *ngIf="payment?.id">{{ 'PAYMENTS.PAYMENTS_FORM.EDIT_PAYMENT' | translate }} #{{ payment?.id }}</span>
      <span *ngIf="!payment?.id">{{ 'PAYMENTS.PAYMENTS_FORM.ADD_PAYMENT' | translate }}</span>

      <small *ngIf="form.get('clean_paymentable_type').value">
        / {{ 'PAYMENTS.PAYMENTS_FORM.PAYMENTABLE_TYPE' | translate }}:
        <strong>{{ form.get('clean_paymentable_type').value }}</strong>
      </small>
      <small *ngIf="form.get('paymentable_id').value">
        / {{ 'PAYMENTS.PAYMENTS_FORM.PAYMENTABLE_ID' | translate }}:
        <strong>{{ form.get('paymentable_id').value }}</strong>
      </small>

      <small *ngIf="form?.get('paymentable')?.value?.ref_number">
        / {{ 'PAYMENTS.PAYMENTS_FORM.PAYMENTABLE_REF_NUMBER' | translate }}:
        <strong>{{ form?.get('paymentable')?.value?.ref_number }}</strong>
      </small>
    </h4>

    <div
      class="btn btn-drag payments-btn-drag"
      #ModalHandle
      container="body"
      [ngbTooltip]="'REQUESTS.REQUEST_FORM.MOVE_MODAL' | translate"
    >
      <i class="far fa-expand-arrows"></i>
    </div>

    <button type="button" class="close payments-btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <ng-scrollbar class="modal-body ps">
    <form id="payment-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
      <div class="row">
        <div class="col-sm-2">
          <app-company-select (select)="companyChange()" [parentFormGroup]="form" [includes]="'bank_accounts.currency'">
          </app-company-select>
        </div>

        <div class="col-sm-3">
          <app-clientable-select [parentFormGroup]="form" #clientableSelectComponent></app-clientable-select>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'PAYMENTS.PAYMENTS_FORM.DATE' | translate }}</label>
            <app-date-picker [FormControl]="form.get('date')"></app-date-picker>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'PAYMENTS.PAYMENTS_FORM.TYPE' | translate }}</label>
            <app-type-select [parentFormGroup]="form" [groupType]="'payment'" [passFormControlName]="'type_id'">
            </app-type-select>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'PAYMENTS.PAYMENTS_FORM.AMOUNT' | translate }}</label>
            <input type="number" class="form-control" formControlName="amount" />
          </div>
        </div>

        <div class="col-sm-1">
          <app-currency-select [parentFormGroup]="form"></app-currency-select>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'PAYMENTS.PAYMENTS_FORM.PAYMENT_METHOD' | translate }}</label>
            <app-type-select
              [parentFormGroup]="form"
              [groupType]="'payment_method'"
              [passFormControlName]="'payment_method_id'"
            >
            </app-type-select>
          </div>
        </div>

        <div
          class="col-sm-3"
          *ngIf="
            form.get('payment_method_id').value == PaymentMethods.BANK_TRANSFER && isCurrentUserAdministratorOrFinance
          "
        >
          <app-bank-account-select [parentFormGroup]="form" [data]="form?.get('company')?.value?.bank_accounts">
          </app-bank-account-select>
        </div>

        <div class="col-sm-1" *ngIf="isCurrentUserAdministratorOrFinance">
          <div class="form-group">
            <label>{{ 'PAYMENTS.PAYMENTS_FORM.FEE_AMOUNT' | translate }}</label>
            <input type="number" class="form-control" formControlName="fee_amount" />
          </div>
        </div>

        <div class="col-sm-1" *ngIf="isCurrentUserAdministratorOrFinance">
          <div class="form-group">
            <label>{{ 'PAYMENTS.PAYMENTS_FORM.FEE_CURRENCY' | translate }}</label>
            <app-currency-select
              [parentFormGroup]="form"
              [passFormControlName]="'fee_currency_id'"
              [hideLabel]="true"
            ></app-currency-select>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'PAYMENTS.PAYMENTS_FORM.REFUNDABLE' | translate }}</label>
            <app-type-select
              [parentFormGroup]="form"
              [groupType]="'payment_refundable'"
              [passFormControlName]="'refundable_id'"
            >
            </app-type-select>
          </div>
        </div>

        <div class="col-sm-1">
          <div class="form-group">
            <label>{{ 'PAYMENTS.PAYMENTS_FORM.REFUNDABLE_PERCENT' | translate }}</label>
            <input type="number" class="form-control" formControlName="refundable_percent" />
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'PAYMENTS.PAYMENTS_FORM.REFUNDABLE_DATE' | translate }}</label>
            <app-date-picker [FormControl]="form.get('refundable_date')" [required]="false"></app-date-picker>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label>{{ 'PAYMENTS.PAYMENTS_FORM.PRIVATE_NOTE' | translate }}</label>
            <textarea
              class="form-control textarea"
              formControlName="private_note"
              pInputTextarea
              autoResize="true"
            ></textarea>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label>{{ 'PAYMENTS.PAYMENTS_FORM.REFERENCE' | translate }}</label>
            <textarea
              class="form-control textarea"
              formControlName="reference"
              pInputTextarea
              autoResize="true"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="form.get('type_id').value != paymentTypes.INCOME">
        <div class="col-sm-12 d-flex">
          <div class="custom-control custom-checkbox me-3">
            <input
              type="checkbox"
              class="custom-control-input"
              formControlName="is_approved"
              id="payment-form-is-approved"
            />
            <label
              class="custom-control-label"
              for="payment-form-is-approved"
              [class.text-success]="form.get('is_approved').value"
            >
              {{ 'PAYMENTS.PAYMENTS_FORM.IS_APPROVED' | translate }}
            </label>
          </div>

          <div class="custom-control custom-checkbox me-3">
            <input
              type="checkbox"
              class="custom-control-input"
              formControlName="is_paid"
              id="payment-form-is-paid"
              (change)="isPaidChange()"
            />
            <label class="custom-control-label" for="payment-form-is-paid">
              {{ 'PAYMENTS.PAYMENTS_FORM.IS_PAID' | translate }}
            </label>
          </div>

          <div class="custom-control custom-checkbox me-3">
            <input
              type="checkbox"
              class="custom-control-input"
              formControlName="has_documents"
              id="payment-form-has-documents"
            />
            <label class="custom-control-label" for="payment-form-has-documents">
              {{ 'PAYMENTS.PAYMENTS_FORM.HAS_DOCUMENTS' | translate }}
            </label>
          </div>
        </div>
      </div>

      <app-bank-accounts-box [bankAccounts]="form.get('clientable')?.value?.bank_accounts"></app-bank-accounts-box>
    </form>
  </ng-scrollbar>

  <div class="modal-footer d-flex justify-content-between">
    <div>
      <app-media-library-button
        *ngIf="form.get('id').value"
        [ngbTooltip]="'PAYMENTS.PAYMENTS_LIST.UPLOAD_DOCUMENTS' | translate"
        container="body"
        [modelId]="form.get('id').value"
        [modelType]="LaravelModels.PAYMENT"
        [collectionName]="'files'"
        [acceptType]="MediaLibraryAcceptTypes.ALL"
        [icon]="'fal fa-file'"
      ></app-media-library-button>
    </div>

    <div class="d-flex">
      <button type="submit" class="btn btn-outline-dark btn-xs" form="payment-form" [disabled]="form.invalid">
        <ng-container *ngIf="isCurrentUserAdministratorOrFinance">
          {{ 'PAYMENTS.PAYMENTS_FORM.SAVE' | translate }}
        </ng-container>

        <ng-container *ngIf="!isCurrentUserAdministratorOrFinance">
          {{ 'PAYMENTS.PAYMENTS_FORM.SEND_FOR_APPROVE' | translate }}
        </ng-container>
      </button>
    </div>
  </div>
</div>
